// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchConnector {
  padding-inline: 20px;
  position: relative;
}
.SearchConnector__Header {
  display: flex;
  padding-block: 3rem;
  gap: 16px;
}
.SearchConnector__Left {
  display: block;
}
.SearchConnector__Right {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.SearchConnector__Title {
  color: var(--neutral-1, #1e1e1e);
  font-family: Syne;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.36px;
}
.SearchConnector__Address {
  display: flex;
  align-items: center;
  gap: 8px;
}
.SearchConnector__Icon {
  height: 16px;
  width: 16px;
}
.SearchConnector__Input {
  padding: 20px 0px;
}
.SearchConnector__SubTitle {
  color: var(--Primary, #00aa74);
  text-align: right;
  font-family: Outfit;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.SearchConnector__Cards {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.SearchConnector__Preloader {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/SearchStationsView/SearchConnectors/SearchConnector.scss"],"names":[],"mappings":"AAGA;EACI,oBAAA;EACA,kBAAA;AAFJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AADR;AAGI;EACI,cAAA;AADR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AADR;AAGI;EACI,gCAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AADR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AADR;AAGI;EACI,YAAA;EACA,WAAA;AADR;AAGI;EACI,iBAAA;AADR;AAGI;EACI,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AADR;AAGI;EACI,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AADR","sourcesContent":["@import '../../../../Styles/sass/variables';\n@import '../../../../Styles/sass/mixins';\n\n.SearchConnector {\n    padding-inline: 20px;\n    position: relative;\n    &__Header {\n        display: flex;\n        padding-block: 3rem;\n        gap: 16px;\n    }\n    &__Left {\n        display: block;\n    }\n    &__Right {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n    }\n    &__Title {\n        color: var(--neutral-1, #1e1e1e);\n        font-family: Syne;\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.36px;\n    }\n    &__Address {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    }\n    &__Icon {\n        height: 16px;\n        width: 16px;\n    }\n    &__Input {\n        padding: 20px 0px;\n    }\n    &__SubTitle {\n        color: var(--Primary, #00aa74);\n        text-align: right;\n        font-family: Outfit;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n    }\n    &__Cards {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n    }\n    &__Preloader {\n        display: flex;\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
